document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.search.includes('open-monogram=true')) {
    setTimeout(function() {
      document.querySelector('.add-monogram.modal-action').dispatchEvent(new Event('click'));
    },2000);
  }
  $('.rg-subcollections').slick({

    // normal options...
    infinite: false,
    slidesToShow: 6,

    // the magic
    responsive: [{

      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
      }

    },{

      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
      }

    },,{

      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      }

    },{

      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 3,
      }

    }, {

      breakpoint: 300,
      settings: "unslick" // destroys slick

    }]
  });
});

updateSaleSwatches();

function updateSaleSwatches() {
  if(document.querySelector('body.template--collection-sale #product-grid .cell__item')) {
    document.querySelectorAll('body.template--collection-sale #product-grid .cell__item').forEach(saleItem => {
      if(saleItem.querySelector('.card-grid-colors')) {
        //setTimeout(function() {
        updatePLPProductCardImage(saleItem.querySelector('.card-grid-colors .swatch-input:first-of-type, .card-grid-colors .swatch-element:first-child'));
        //saleItem.querySelector('.card-grid-colors .swatch-element:first-child').dispatchEvent(new Event('click'));
        //},1)
      }
    })
  }
}

function updatePLPProductCardImage(swatch) {
  const button = swatch.classList.contains('swatch-input') ? swatch.closest('.swatch-element') : swatch;
  const input = button.querySelector('.swatch-input');
  var image = swatch.getAttribute("data-varimg") || button.getAttribute("data-varimg");
  var color = swatch.getAttribute("data-color") || button.getAttribute("data-color");
  var prodId = swatch.getAttribute("data-prodId") || button.getAttribute("data-prodId");
  var varId = swatch.getAttribute("data-varid") || button.getAttribute("data-varid");
  var parentSwatch = swatch.closest('.card--media');
  var parent = swatch.closest('.card-wrapper');
  parentSwatch.querySelectorAll('.swatch-element').forEach(function (el, index) {
    el.classList.remove('active');
  });
  button.classList.add('active');
  if (input) {
    input.checked = true;
  }
  var imgElem =  parentSwatch.querySelectorAll('.image-content__image')[0];
  imgElem.src = image;
  imgElem.srcset = image;
  if ( parent.querySelector('#color-'+prodId) && parent.querySelector('#size-'+prodId) ) {
    var size = parent.querySelector('#size-'+prodId).value
    parent.querySelector('#color-'+prodId).value = color;
    /* setting variant */
    setVariantCard(parent,prodId,color,size);
  }
  const overlayLink = parent.querySelector('.overlay-link');
  if (overlayLink){
    const link = overlayLink.getAttribute('href').split('?')[0];
    parent.querySelector('.overlay-link').setAttribute('href',link+"?variant="+varId);
  }

}

document.addEventListener('cart:updated', (e) => {

  if(e.detail?.items?.length > 0) {
    let items = e.detail.items;
    removeOrphanedMonogramCartItems(items)
  }
});

/**
 * Removes orphaned monogram items from the shopping cart. A monogram item is considered orphaned
 * if it has a `RecipeID` property and is not paired with another item in the cart with a matching `RecipeID`.
 *
 * @param {Array} items - The array of cart items to be checked for orphaned monogram items. Each item contains properties such as `key`, `quantity`, and `properties`.
 * @return {void} This function does not return a value.
 */
function removeOrphanedMonogramCartItems(items) {
  items.forEach((item) => {

    // If the item is a monogram item but isn't paired with another cart item, remove it from the cart
    if(item.properties.hasOwnProperty('RecipeID')) {
      let synchronizeKey = item.properties['RecipeID'].replace('uc-','');
      const pairedItem = items.find(cartItem=>cartItem.properties.RecipeID === synchronizeKey);
      if(typeof pairedItem == "undefined") {

        const body = JSON.stringify({
          id: item.key,
          quantity: 0,
        });

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          ...{ body },
        }).then((res) => {
          console.log(res.json());
        });

      }
    }

  });
}
